import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { useFeaturedPhotosPromoX3 } from 'components/block/FeaturedPhotosPromoX3/hooks/useFeaturedPhotosPromoX3'

export const FeaturedPhotoTextSwitch: FC = () => {
  const { isFeaturedPhotosPromoX3Active } = useFeaturedPhotosPromoX3()
  return isFeaturedPhotosPromoX3Active ? (
    <FormattedMessage
      id="storefront.legend.rating.x3.next"
      defaultMessage="В 3 раза больше гарантированных показов в Знакомствах"
    />
  ) : (
    <FormattedMessage
      id="promo.featured_photos.description"
      defaultMessage="Активируй гарантированные показы — получи больше лайков"
    />
  )
}
